export default __webpack_public_path__ + "static/media/emmanuel.ff50a07b.png";